setTimeout(() => {
  let stickyContainer = document.querySelector('[id^="sticky-container-"]');
  
  if(stickyContainer){
    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1
    });
    
    document.querySelectorAll('.product [data-hide-sticky]').forEach(target => {
      observer.observe(target);
    })
    
    function handleIntersection(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyContainer.classList.add('u-hidden');
        }
        else {
          stickyContainer.classList.remove('u-hidden');
        }
      })
    }
    
    
    let sticky_button = document.querySelector('.block_producy-stickybtn-inner .product-form__submit');
    let product_button = document.querySelector('.buy_button_and_quantity_selecter .product-form__submit');
    
      sticky_button.addEventListener('click', ()=> {
        product_button.click();
      })
  }
}, 2000);




